// This code has been fully generated by an AI.

export async function prepareProfilePicture(file: File): Promise<Blob> {
  if (!['image/jpeg', 'image/png'].includes(file.type)) {
    throw new Error('Als Profilbild sind nur JPEG und PNG erlaubt.');
  }
  if (file.size === 0 || file.size > 5 * 1024 * 1024) {
    throw new Error('Bitte ein Bild mit maximal 5 MiB auswählen.');
  }
  const image = await createImageBitmap(file).catch(() => {
    throw new Error('Das Profilbild konnte nicht gelesen werden.');
  });
  try {
    const scale = Math.min(1, 240 / image.width, 240 / image.height);
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.width * scale));
    canvas.height = Math.max(1, Math.round(image.height * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Das Profilbild konnte nicht verarbeitet werden.');
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(result => {
        if (!result) {
          reject(new Error('Das Profilbild konnte nicht verarbeitet werden.'));
          return;
        }
        resolve(result);
      }, 'image/png');
    });
  } finally {
    image.close();
  }
}
